import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75cf7194"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "请留下您的联系方式，我们将尽快联系您", -1))
const _hoisted_2 = { class: "item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label required" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "姓名"),
  /*#__PURE__*/_createTextVNode("： ")
], -1))
const _hoisted_4 = { class: "item-content" }
const _hoisted_5 = { class: "item-error" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label required" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "手机号码"),
  /*#__PURE__*/_createTextVNode("： ")
], -1))
const _hoisted_8 = { class: "item-content" }
const _hoisted_9 = { class: "item-error" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "方便联系时间"),
  /*#__PURE__*/_createTextVNode("： ")
], -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "您目前所处阶段"),
  /*#__PURE__*/_createTextVNode("： ")
], -1))
const _hoisted_14 = {
  class: "item",
  style: {"flex-direction":"column"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "您的需求：", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确定")

import { reactive, ref } from 'vue'
import { ElInput, ElSelect, ElOption, ElButton, ElMessage } from 'element-plus'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/message/style/css'
import { consultCloud } from '@/api/index'
interface FormO {
    name: string,
    nameCheck: boolean,
    phone: string,
    phoneCheck: boolean,
    time: number | undefined,
    stage: number | undefined,
    other: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function getFormO(): FormO {
    return {
        name: '',
        nameCheck: false,
        phone: '',
        phoneCheck: false,
        time: undefined,
        stage: undefined,
        other: ''
    }
}
const btnLoading = ref(false)
const form = reactive(getFormO())
const times = reactive([
    { name: '上午', value: 0 },
    { name: '下午', value: 1 },
    { name: '晚上', value: 2 },
    { name: '随时', value: 3 },
])
const stages = reactive([
    { name: '已开店', value: 0 },
    { name: '未开店，但从事过婚恋行业', value: 1 },
    { name: '未从事过婚恋行业，在寻找创业机会', value: 2 },
    { name: '其他', value: 3 },
])
function onBlur<T extends keyof FormO>(value: string, check: T): boolean {
    let flag: boolean
    if (!value) {
        flag = true
    } else {
        if (check === 'phoneCheck' && !(/^1\d{10}$/.test(value))) {
            flag = true
        } else {
            flag = false
        }
    }
    (form[check] as boolean) = flag
    return flag
}
function submit() {
    const { name, phone, stage, time, other } = form
    if (onBlur(name, 'nameCheck') || onBlur(phone, 'phoneCheck')) {
        return
    }
    btnLoading.value = true
    consultCloud({
        name,
        phone,
        other,
        stage: stage != undefined ? stages[stage].name : '',
        time: time != undefined ? times[time].name : ''
    }).then(res => {
        console.log(res)
        if (res.code === 200) {
            ElMessage({
                type: 'success',
                message: '联系成功',
                center: true
            })
            Object.assign(form, getFormO())
        }
    }).finally(() => {
        btnLoading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ElInput), {
          class: "item-input",
          modelValue: _unref(form).name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (onBlur(_unref(form).name, 'nameCheck'))),
          maxlength: 30,
          "show-word-limit": "",
          placeholder: "请输入您的姓名"
        }, null, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("div", _hoisted_5, "姓名不能为空", 512), [
          [_vShow, _unref(form).nameCheck]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(ElInput), {
          class: "item-input",
          modelValue: _unref(form).phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).phone) = $event)),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (onBlur(_unref(form).phone, 'phoneCheck'))),
          type: "number",
          placeholder: "请输入您的手机号码"
        }, null, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("div", _hoisted_9, "手机号码格式不正确", 512), [
          [_vShow, _unref(form).phoneCheck]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_unref(ElSelect), {
        modelValue: _unref(form).time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).time) = $event)),
        class: "item-content item-input",
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(times), (item) => {
            return (_openBlock(), _createBlock(_unref(ElOption), {
              key: item.value,
              label: item.name,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_unref(ElSelect), {
        modelValue: _unref(form).stage,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).stage) = $event)),
        class: "item-content item-input",
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stages), (item) => {
            return (_openBlock(), _createBlock(_unref(ElOption), {
              key: item.value,
              label: item.name,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode(_unref(ElInput), {
        class: "item-textarea",
        modelValue: _unref(form).other,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).other) = $event)),
        type: "textarea",
        maxlength: 500,
        resize: "none",
        placeholder: "您可以在这里简单描述一下您的需求，以便我们更好地帮您解决问题",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_unref(ElButton), {
      class: "button",
      type: "primary",
      loading: btnLoading.value,
      onClick: submit
    }, {
      default: _withCtx(() => [
        _hoisted_16
      ]),
      _: 1
    }, 8, ["loading"])
  ], 64))
}
}

})